/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowALeftIcon16Solid = forwardRef('ArrowALeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.68 12.038a1.25 1.25 0 0 1-1.767 1.768L1.985 9.878a2.656 2.656 0 0 1 0-3.756l3.928-3.928A1.25 1.25 0 1 1 7.68 3.962L4.892 6.75H13.5a1.25 1.25 0 0 1 0 2.5H4.892l2.788 2.788Z" })));
});
